module.exports = __webpack_public_path__ + "pic_bizny_web_04-640@2x.png?8aeb53cce9523ea667d6ad4af28571cf";